import React from 'react';

/** The TNS wordmark used across the flow. */
export const TnsWordmark = ({
  className = ''
}: {
  className?: string;
}) => <div className={`text-center ${className}`} data-id="element-883" data-mp="39q73cwanp4he">
    <p className="font-display text-lg sm:text-xl tracking-[0.18em] uppercase text-tns-gold" data-id="element-884" data-mp="2us6bcdcwfcsj">
      The Networking Salon
    </p>
  </div>;
interface ProgressProps {
  step: 1 | 2;
}
export const OnboardingProgress = ({
  step
}: ProgressProps) => <div className="mb-10 sm:mb-14" data-id="element-885" data-mp="3nhvh140k010h">
    <div className="flex items-center gap-3 max-w-xs mx-auto" aria-hidden="true" data-id="element-886" data-mp="3niwzhtjwfps8">
      <span className="h-[3px] flex-1 rounded-full bg-tns-gold transition-colors duration-500" data-id="element-887" data-mp="3sf5biy2sv2v6" />
      <span className={`h-[3px] flex-1 rounded-full transition-colors duration-500 ${step === 2 ? 'bg-tns-gold' : 'bg-tns-ivory-dark'}`} data-id="element-888" data-mp="3dqhgqu0s2x6a" />
    </div>
    <p className="mt-3 text-center font-body text-xs uppercase tracking-[0.18em] text-tns-charcoal-soft" data-id="element-889" data-mp="a9ij1h4eza9c">
      Step {step} of 2
    </p>
  </div>;
interface ShellProps {
  children: React.ReactNode;
}

/** Warm White canvas used for the two form steps. */
export const OnboardingShell = ({
  children
}: ShellProps) => <main className="min-h-[100dvh] bg-tns-ivory font-body" data-id="element-890" data-mp="2d5g1arn76zpj">
    <div className="mx-auto w-full max-w-2xl px-5 sm:px-8 py-12 sm:py-20" data-id="element-891" data-mp="2rsrc2rbk2fol">
      {children}
    </div>
  </main>;
interface StepHeaderProps {
  heading: string;
  subtext: string;
}
export const StepHeader = ({
  heading,
  subtext
}: StepHeaderProps) => <header className="mb-10 sm:mb-14" data-id="element-892" data-mp="30vadd6zp0k8q">
    <h1 className="font-display font-medium text-tns-navy leading-[1.15] mb-4" style={{
    fontSize: 'clamp(1.9rem, 5.5vw, 3rem)'
  }} data-id="element-893" data-mp="2vumb1p60kgz7">
      {heading}
    </h1>
    <p className="font-body text-tns-charcoal-soft leading-relaxed max-w-xl" style={{
    fontSize: 'clamp(1rem, 1.6vw, 1.125rem)'
  }} data-id="element-894" data-mp="3ap0xy0sp8aj5">
      {subtext}
    </p>
  </header>;
interface GoldButtonProps {
  children: React.ReactNode;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

/** The single dominant CTA. TNS Gold on navy text, full width on mobile. */
export const GoldButton = ({
  children,
  type = 'button',
  onClick,
  disabled,
  className = ''
}: GoldButtonProps) => <button type={type} onClick={onClick} disabled={disabled} className={`w-full sm:w-auto min-h-[52px] px-9 py-3.5 rounded-lg bg-tns-gold text-tns-navy font-body font-semibold text-base tracking-wide shadow-lg shadow-tns-gold/20 transition-all duration-200 hover:bg-tns-gold-light hover:-translate-y-0.5 hover:shadow-tns-gold/30 active:translate-y-0 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tns-gold focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0 ${className}`} data-id="element-895" data-mp="2a2tl0ss6ntgi">
    {children}
  </button>;